"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EdgeControl_config, _EdgeControl_direction, _EdgeControl_initialDirection, _EdgeControl_initialEdge, _EdgeControl_position, _EdgeControl_dragStartP1, _EdgeControl_dragStartP2, _EdgeControl_dragStartPos;
Object.defineProperty(exports, "__esModule", { value: true });
exports.EdgeControl = void 0;
const gl_matrix_1 = require("gl-matrix");
/**
 * Runtime representation of an edge control point.
 *
 * The control sits at the midpoint of the edge (point1 → point2) and holds a
 * direction vector that is rotated whenever the edge orientation changes relative
 * to its initial orientation.
 */
class EdgeControl {
    constructor(config, p1, p2) {
        _EdgeControl_config.set(this, void 0);
        _EdgeControl_direction.set(this, void 0);
        _EdgeControl_initialDirection.set(this, void 0);
        _EdgeControl_initialEdge.set(this, void 0);
        _EdgeControl_position.set(this, void 0);
        // Drag state
        _EdgeControl_dragStartP1.set(this, void 0);
        _EdgeControl_dragStartP2.set(this, void 0);
        _EdgeControl_dragStartPos.set(this, void 0);
        __classPrivateFieldSet(this, _EdgeControl_config, config, "f");
        const edge = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), p2, p1);
        __classPrivateFieldSet(this, _EdgeControl_initialEdge, gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), edge), "f");
        __classPrivateFieldSet(this, _EdgeControl_initialDirection, gl_matrix_1.vec3.clone(config.direction), "f");
        __classPrivateFieldSet(this, _EdgeControl_direction, gl_matrix_1.vec3.clone(config.direction), "f");
        __classPrivateFieldSet(this, _EdgeControl_position, gl_matrix_1.vec3.scale(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), p1, p2), 0.5), "f");
    }
    get config() {
        return __classPrivateFieldGet(this, _EdgeControl_config, "f");
    }
    get direction() {
        return __classPrivateFieldGet(this, _EdgeControl_direction, "f");
    }
    get point1() {
        return __classPrivateFieldGet(this, _EdgeControl_config, "f").point1;
    }
    get point2() {
        return __classPrivateFieldGet(this, _EdgeControl_config, "f").point2;
    }
    get position() {
        return __classPrivateFieldGet(this, _EdgeControl_position, "f");
    }
    get type() {
        return "edge";
    }
    /**
     * Restores point1 and point2 to their pre-drag positions, resets the
     * visual midpoint, and clears drag state.
     */
    cancel(moveTemporary) {
        if (__classPrivateFieldGet(this, _EdgeControl_dragStartP1, "f") !== undefined &&
            __classPrivateFieldGet(this, _EdgeControl_dragStartP2, "f") !== undefined) {
            moveTemporary(__classPrivateFieldGet(this, _EdgeControl_config, "f").point1, __classPrivateFieldGet(this, _EdgeControl_dragStartP1, "f"));
            moveTemporary(__classPrivateFieldGet(this, _EdgeControl_config, "f").point2, __classPrivateFieldGet(this, _EdgeControl_dragStartP2, "f"));
        }
        if (__classPrivateFieldGet(this, _EdgeControl_dragStartPos, "f") !== undefined) {
            gl_matrix_1.vec3.copy(__classPrivateFieldGet(this, _EdgeControl_position, "f"), __classPrivateFieldGet(this, _EdgeControl_dragStartPos, "f"));
        }
        __classPrivateFieldSet(this, _EdgeControl_dragStartP1, undefined, "f");
        __classPrivateFieldSet(this, _EdgeControl_dragStartP2, undefined, "f");
        __classPrivateFieldSet(this, _EdgeControl_dragStartPos, undefined, "f");
    }
    /**
     * Refreshes the direction vector from the committed edge orientation and
     * clears drag state.
     */
    end(getPosition) {
        const p1 = getPosition(__classPrivateFieldGet(this, _EdgeControl_config, "f").point1);
        const p2 = getPosition(__classPrivateFieldGet(this, _EdgeControl_config, "f").point2);
        this.updateFromPoints(p1, p2);
        __classPrivateFieldSet(this, _EdgeControl_dragStartP1, undefined, "f");
        __classPrivateFieldSet(this, _EdgeControl_dragStartP2, undefined, "f");
        __classPrivateFieldSet(this, _EdgeControl_dragStartPos, undefined, "f");
    }
    /**
     * Projects the mouse ray onto the control's direction axis via a
     * line-line closest-point calculation, moves point1 and point2 by the
     * resulting delta, and returns the new visual midpoint position.
     *
     * When `restrictedPosition` is supplied (e.g. the result of
     * `restrictionManager.rayTrace`) the unconstrained line-line computation is
     * skipped.  Instead the restricted world-space point is projected onto the
     * direction axis so that the movement is both restriction-aware AND stays
     * on the desired drag direction.
     *
     * Returns undefined when the ray and direction axis are parallel
     * (degenerate case — no movement applied).
     */
    move(ray, moveTemporary, restrictedPosition, applyConstraints) {
        const dir = __classPrivateFieldGet(this, _EdgeControl_direction, "f");
        let t;
        if (restrictedPosition !== undefined) {
            // Project the restriction-constrained point onto the direction axis:
            //   t = dot(restrictedPosition - dragStartPos, dir) / dot(dir, dir)
            const dirLenSq = gl_matrix_1.vec3.dot(dir, dir);
            if (dirLenSq < 1e-10)
                return undefined;
            const diff = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), restrictedPosition, __classPrivateFieldGet(this, _EdgeControl_dragStartPos, "f"));
            t = gl_matrix_1.vec3.dot(diff, dir) / dirLenSq;
        }
        else {
            const rayOrigin = ray.origin;
            const rayDir = ray.direction;
            // Line-line closest-point:
            //   Line 1 (control axis): dragStartPos + t * dir
            //   Line 2 (mouse ray)   : ray.origin   + s * ray.direction
            const w = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _EdgeControl_dragStartPos, "f"), rayOrigin);
            const a = gl_matrix_1.vec3.dot(dir, dir);
            const b = gl_matrix_1.vec3.dot(dir, rayDir);
            const c = gl_matrix_1.vec3.dot(rayDir, rayDir);
            const d = gl_matrix_1.vec3.dot(w, dir);
            const e = gl_matrix_1.vec3.dot(w, rayDir);
            const denom = a * c - b * b;
            if (Math.abs(denom) < 1e-10)
                return undefined; // lines are parallel
            t = (b * e - c * d) / denom;
        }
        // If a constraint evaluator is provided, find the tightest valid scalar t
        // so that both endpoints always translate rigidly together.
        //
        // Strategy: evaluate applyConstraints on each endpoint with an overrides
        // map containing both unconstrained positions, then back-project the
        // clamped position onto the direction axis to get the effective t for
        // each component.  The most conservative (smallest |t|) is used.
        if (applyConstraints !== undefined) {
            const delta = gl_matrix_1.vec3.scale(gl_matrix_1.vec3.create(), dir, t);
            const newP1Unc = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _EdgeControl_dragStartP1, "f"), delta);
            const newP2Unc = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _EdgeControl_dragStartP2, "f"), delta);
            const overrides = new Map([
                [__classPrivateFieldGet(this, _EdgeControl_config, "f").point1, newP1Unc],
                [__classPrivateFieldGet(this, _EdgeControl_config, "f").point2, newP2Unc],
            ]);
            const cp1 = applyConstraints(newP1Unc, __classPrivateFieldGet(this, _EdgeControl_config, "f").point1, overrides, __classPrivateFieldGet(this, _EdgeControl_dragStartP1, "f"));
            const cp2 = applyConstraints(newP2Unc, __classPrivateFieldGet(this, _EdgeControl_config, "f").point2, overrides, __classPrivateFieldGet(this, _EdgeControl_dragStartP2, "f"));
            let tClamped = t;
            for (let i = 0; i < 3; i++) {
                const di = dir[i];
                if (Math.abs(di) < 1e-10)
                    continue;
                const t1 = (cp1[i] - __classPrivateFieldGet(this, _EdgeControl_dragStartP1, "f")[i]) / di;
                if (Math.abs(t1) < Math.abs(tClamped))
                    tClamped = t1;
                const t2 = (cp2[i] - __classPrivateFieldGet(this, _EdgeControl_dragStartP2, "f")[i]) / di;
                if (Math.abs(t2) < Math.abs(tClamped))
                    tClamped = t2;
            }
            t = tClamped;
        }
        const delta = gl_matrix_1.vec3.scale(gl_matrix_1.vec3.create(), dir, t);
        const newP1 = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _EdgeControl_dragStartP1, "f"), delta);
        const newP2 = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), __classPrivateFieldGet(this, _EdgeControl_dragStartP2, "f"), delta);
        moveTemporary(__classPrivateFieldGet(this, _EdgeControl_config, "f").point1, newP1);
        moveTemporary(__classPrivateFieldGet(this, _EdgeControl_config, "f").point2, newP2);
        // Update visual position to the new midpoint.
        gl_matrix_1.vec3.add(__classPrivateFieldGet(this, _EdgeControl_position, "f"), newP1, newP2);
        gl_matrix_1.vec3.scale(__classPrivateFieldGet(this, _EdgeControl_position, "f"), __classPrivateFieldGet(this, _EdgeControl_position, "f"), 0.5);
        return gl_matrix_1.vec3.clone(__classPrivateFieldGet(this, _EdgeControl_position, "f"));
    }
    /**
     * Recomputes the midpoint position and direction from the current geometry
     * (e.g. after an undo/redo).
     */
    refreshAll(getPosition) {
        const p1 = getPosition(__classPrivateFieldGet(this, _EdgeControl_config, "f").point1);
        const p2 = getPosition(__classPrivateFieldGet(this, _EdgeControl_config, "f").point2);
        this.updateFromPoints(p1, p2);
    }
    /**
     * Recomputes this control's midpoint and direction if the moved point is one
     * of the two edge endpoints. Returns true if the control was affected.
     */
    refreshForMovedPoint(movedIndex, getPosition) {
        if (__classPrivateFieldGet(this, _EdgeControl_config, "f").point1 !== movedIndex &&
            __classPrivateFieldGet(this, _EdgeControl_config, "f").point2 !== movedIndex) {
            return false;
        }
        const p1 = getPosition(__classPrivateFieldGet(this, _EdgeControl_config, "f").point1);
        const p2 = getPosition(__classPrivateFieldGet(this, _EdgeControl_config, "f").point2);
        this.updateFromPoints(p1, p2);
        return true;
    }
    /**
     * Snapshots the initial edge endpoint positions and visual midpoint so that
     * subsequent move() calls can compute the correct displacement.
     */
    start(getPosition) {
        __classPrivateFieldSet(this, _EdgeControl_dragStartP1, gl_matrix_1.vec3.clone(getPosition(__classPrivateFieldGet(this, _EdgeControl_config, "f").point1)), "f");
        __classPrivateFieldSet(this, _EdgeControl_dragStartP2, gl_matrix_1.vec3.clone(getPosition(__classPrivateFieldGet(this, _EdgeControl_config, "f").point2)), "f");
        __classPrivateFieldSet(this, _EdgeControl_dragStartPos, gl_matrix_1.vec3.clone(__classPrivateFieldGet(this, _EdgeControl_position, "f")), "f");
        return true;
    }
    /**
     * Recomputes the midpoint position and the rotated direction from the current
     * edge endpoints.
     *
     * The direction is rotated by the same rotation that maps the initial
     * normalized edge vector to the current normalized edge vector.  The magnitude
     * of the direction vector is preserved.
     */
    updateFromPoints(p1, p2) {
        gl_matrix_1.vec3.add(__classPrivateFieldGet(this, _EdgeControl_position, "f"), p1, p2);
        gl_matrix_1.vec3.scale(__classPrivateFieldGet(this, _EdgeControl_position, "f"), __classPrivateFieldGet(this, _EdgeControl_position, "f"), 0.5);
        const edge = gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), p2, p1);
        const len = gl_matrix_1.vec3.len(edge);
        if (len < 1e-10)
            return;
        const currentEdge = gl_matrix_1.vec3.scale(gl_matrix_1.vec3.create(), edge, 1 / len);
        const q = gl_matrix_1.quat.rotationTo(gl_matrix_1.quat.create(), __classPrivateFieldGet(this, _EdgeControl_initialEdge, "f"), currentEdge);
        gl_matrix_1.vec3.transformQuat(__classPrivateFieldGet(this, _EdgeControl_direction, "f"), __classPrivateFieldGet(this, _EdgeControl_initialDirection, "f"), q);
    }
}
exports.EdgeControl = EdgeControl;
_EdgeControl_config = new WeakMap(), _EdgeControl_direction = new WeakMap(), _EdgeControl_initialDirection = new WeakMap(), _EdgeControl_initialEdge = new WeakMap(), _EdgeControl_position = new WeakMap(), _EdgeControl_dragStartP1 = new WeakMap(), _EdgeControl_dragStartP2 = new WeakMap(), _EdgeControl_dragStartPos = new WeakMap();
//# sourceMappingURL=EdgeControl.js.map